<template>
  <main role="main" class="py-4">
    <b-container fluid="xxl">
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("meetingCountDetails") }}</h4>
        <div>
          <!-- <b-button variant="outline-secondary" @click="onClickReloadBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button> -->
          <b-button variant="outline-success" :disabled="!totalItems || isExportingToExcel" @click="debouncenOnClickExportToExcel">
          <b-icon-download class="mr-2"></b-icon-download> {{ $t("export") }}
        </b-button>
        </div>
      </div>

      <b-form class="d-flex flex-row align-items-center mb-3" @submit.prevent="debounceOnClickSearchBtn">
        <b-form-input class="mr-3" type="search" style="width: 280px;"
                      minlength="2" maxlength="200" v-model="searchText"
                      :placeholder="$t('search')" 
                      @keyup.enter="debounceOnClickSearchBtn" />
        <b-form-select v-if="isUserAdmin()" class="mr-3" :options="searchAreaOptions" v-model="searchAreaId" style="width: 280px;"></b-form-select>
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3">{{ $t("fromDate") }}</div>
          <b-form-datepicker v-model="startDate" value-as-date required
                             :max="new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3">{{ $t("toDate") }}</div>
          <b-form-datepicker v-model="endDate" value-as-date required
                             :max="new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <b-button type="submit" variant="primary">{{ $t("search") }}</b-button>
      </b-form>
      <div>
           <div class="text-danger">{{ formErrorMsg }}</div>
      </div>
      <b-table ref="table" :items="tableItemProvider" hover primary-key="id" :fields="tableFields" :busy="isLoading" show-empty
               :per-page="itemsPerPage" :current-page="currentPage">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(name)="data">
          <router-link :to="'/customers/details/' + data.item.customerId + '/meetings'">
            {{ data.item.name }}
          </router-link>
        </template>
        
              <template v-slot:cell(subPlan)="data">
            
            {{ data.item.subPlan}} 
        </template>
          <template v-slot:cell(fromDate)="data">
            
            {{ formatDate(data.item.subPlanStartDate	)  }}  -  {{  formatDate(data.item.subPlanEndDate	)}} 
        </template>
      </b-table>

      <div class="d-flex flex-row align-items-center justify-content-between">
        <!-- <b-button variant="link" :disabled="!totalItems || isExportingToExcel" @click="onClickExportToExcel">
          <b-icon-download class="mr-2"></b-icon-download> {{ $t("export") }}
        </b-button> -->
        <div></div>
        <div class="d-flex flex-row align-items-center">
          <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">{{ $t("resultCount", { count: totalItems }) }}</div>
          <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems" :per-page="itemsPerPage"></b-pagination>
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections"></b-form-select>
        </div>
      </div>

    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Ref, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import moment from "moment";
  import BaseComponent from "@/components/BaseComponent";
  import {BvTableFieldArray} from "bootstrap-vue";
  import {BTable, BvTableCtxObject, BvTableProviderPromiseResult} from "bootstrap-vue/src/components/table";
  import * as reportService from "@/service/reportService";
  import * as areaService from "@/service/areaService";
  import { BounceTimes } from '../enums/TimesNumbers';
  import * as exportService from "@/service/exportService";

  @Component
  export default class MeetingCount2 extends BaseComponent {

    searchText = "";

    searchAreaId: number = null;
    searchAreaOptions = [];

    startDate: Date = null;
    endDate: Date = null;
    formErrorMsg = "";
    isLoading = false;

    @Ref("table") table: BTable;
    tableFields: BvTableFieldArray = [
      {
        key: "customerId",
        label: "ID",
        thClass: "text-nowrap",
      },
      {
        key: "name",
        label: this.$t("customerNameShort").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      {
        key: "areaName",
        label: this.$t("saleArea").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
       {
        key: "customerAddress",
        label: this.$t("address").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      // Tạm mai 20/06 Thái đi làm lại chỉnh api sau
      {
        key: "subPlanName",
        label: this.$t("subscriptionPlan").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
     
      {
        key: "fromDate",
        label: this.$t("khoangthoigian").toString(),
        thClass: "text-nowrap",
        formatter: value => moment(value).format("DD/MM/YYYY")
      },
      // {
      //   key: "toDate",
      //   label: this.$t("toDate").toString(),
      //   thClass: "text-nowrap",
      //   formatter: value => moment(value).format("DD/MM/YYYY")
      // },
      {
        key: "meetingEnded",
        label: this.$t("done").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "meetingInProgress",
        label:  this.$t("inprogress").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "meetingPending",
        label: this.$t("pending").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "meetingCancelled",
        label: this.$t("cancelled").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "maxParticipant",
        label: this.$t("maxParticipant").toString(),
        thClass: "text-nowrap",
      },
    ];

    isExportingToExcel = false;

    itemsPerPageSelections = [
      { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
      { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
      { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
      { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
    ];
    itemsPerPage = 20;
    currentPage = 1;
    totalItems = 0;


    mounted() {
      this.startDate = moment().subtract(30, "days").startOf("day").toDate();
      this.endDate = moment().endOf("day").toDate();
      this.fetchAreas();
    }
 formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [day, month, year].join('/');
  }
    async fetchAreas() {
      try {
        const areas = await areaService.getAll();
        this.searchAreaOptions = areas.map(a => ({ value: a.id, text: a.name }));
        this.searchAreaOptions.unshift({ value: null, text: this.$t("all").toString()});

      } catch (e) {
        this.toastError(e);
      }
    }

    onClickReloadBtn() {
      this.searchText = "";
      this.startDate = moment().subtract(30, "days").startOf("day").toDate();
      this.endDate = moment().endOf("day").toDate();
      this.formErrorMsg = "";
      this.itemsPerPage = 20;
      this.currentPage = 1;
      this.totalItems = 0;

      this.table.refresh();
    }


    /*
    
          fromDate:  this.startDate[0] && this.startDate[1] ? this.startDate[0].toISOString().replace(".000Z", "").replaceAll(":", "-") : null,
          toDate:  this.endDate[0] && this.endDate[1] ? this.endDate[0].toISOString().replace(".000Z", "").replaceAll(":", "-") : null,
    
    */
    async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
       this.formErrorMsg="";
      if (this.startDate.getTime() > this.endDate.getTime()) {
        this.formErrorMsg = this.$t("invalidDateRange").toString();
        return;
      } else {

        try {

          const customerListRes = await reportService.getCustomerMeetingsCountDetails({
            fromDate: this.startDate.toISOString(),
            toDate: this.endDate.toISOString(),
            page: ctx.currentPage,
            pageSize: this.itemsPerPage,

            q: this.searchText?.trim(),
            areaId: this.searchAreaId
          });

          this.totalItems = customerListRes.total;
          return customerListRes.data;

        } catch (e) {
          this.toastError(e);
          return [];
        }

      }
      
    }
  debounceOnClickSearchBtn  = _.debounce(() => {
    this.onClickSearchBtn ();
  }, BounceTimes.BOUNCETIMES);
  debouncenOnClickExportToExcel  = _.debounce(() => {
    this.onClickExportToExcel ();
  }, BounceTimes.BOUNCETIMES);
    onClickSearchBtn() {
      this.table.refresh();
  }


    //Các trường sẽ xuất file excell STT	ID khách hàng	Tên	Số điện thoại	Email	Địa chỉ	Khu vực	Người tạo	Thời điểm tạo	Gói cước	Ngày bắt đầu	Ngày kết thúc	Số ngày còn hiệu lục	Loại tài khoản	Đã thực hiện	Đang diễn ra	Đang chờ	Đã hủy	SL tham dự lớn nhất
    async onClickExportToExcel() {
      try {
        this.isExportingToExcel = true;
        const customers = [];

        while (true) {
          const pageSize = 500;
          const customerListRes = await reportService.getCustomerMeetingsCountDetails({
            fromDate: this.startDate.toISOString(),
            toDate: this.endDate.toISOString(),
            page: 1,
            pageSize,
            q: this.searchText?.trim(),
            areaId: this.searchAreaId
          });
          const part: any[] = Array.isArray(customerListRes.data)? customerListRes.data : [];
          customers.push(...part);
          if (part.length < pageSize) break;
        }

        const sheetData = customers.map((it,index) => [
          index+1,
          it.customerId,
          it.name,
          it.phoneNumber,
          it.email,
          it.customerAddress,
          it.areaName,
          it.createdBy,
          moment(it.createdAt).format("DD/MM/YYYY"),
          it.subPlanName,
          moment(it.subPlanStartDate).format("DD/MM/YYYY"),
          moment(it.subPlanEndDate).format("DD/MM/YYYY"),
          it.remainingDays,
          it.customerSource,
          it.meetingEnded,
          it.meetingInProgress,
          it.meetingPending,
          it.meetingCancelled,
          it.maxParticipant
        ]);
        //STT	ID khách hàng	Tên	Số điện thoại	Email	Địa chỉ	Khu vực	Người tạo	Thời điểm tạo	Gói cước	Ngày bắt đầu	Ngày kết thúc	Số ngày còn hiệu lục	Loại tài khoản	Đã thực hiện	Đang diễn ra	Đang chờ	Đã hủy	SL tham dự lớn nhất
      // Thêm dòng tiêu đề "Thống kê báo cáo" vào đầu mảng dữ liệu
      // Thêm dòng tiêu đề cột vào mảng dữ liệu
        sheetData.unshift([
          "STT",
          this.$t("IdKH"),
          this.$t("name"),
          this.$t("phoneNumber"),
          this.$t("email"),
          this.$t("address"),
          this.$t("saleArea"),
          this.$t("createBy"),
          this.$t("thoidiemtao"),
          this.$t("goicuoc"),
          this.$t("fromDate"),
          this.$t("toDate"),
          this.$t("songayconlai"),
          this.$t("loaitaikhoan"),
          this.$t("done"),
          this.$t("inprogress"),
          this.$t("meetingStatusPending"),
          this.$t("cancelled"),
          this.$t("maxParticipant"),
        ]);
      sheetData.unshift([  this.$t("sanluongkhachhangtu") +   " " +    moment(this.startDate).format("DD/MM/YYYY")+" - "+    moment(this.endDate).format("DD/MM/YYYY"),]);

       await exportService.exportExcelFile(sheetData, 'ThongKeChiTietSoLuongCuocHop', 'TK_ChiTietSoLuongCH');
      } catch (e) {
        console.error(e);
        this.toastError(e);

      } finally {
        this.isExportingToExcel = false;
      }
    }

  }
</script>
